// import { alpha } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

const size = 200;

export const useStyle = makeStyles((theme) => ({
  paperStyle: {
    display: 'flex',
    width: '400px',
    flexDirection: 'column',
    padding: `${theme.spacing(6)} ${theme.spacing(4)}`,
    gap: theme.spacing(2),
  },
  logo: {
    minHeight: '32px',
    height: '180px'
  },
  cubesAnimation: {
    height: '100%',
    width: '900px'
  },
  rowCubes: {
    position: 'relative'
  },
  cube: {
    height: size,
    width: size,
    position: 'absolute',
    top: 0,
    left: 0
  },
  cubeSide: {
    height: size,
    width: size,
    position: 'absolute',
    left: size / 3.3,
    top: size / 6.3
  },
  cubeLast: {
    height: size,
    width: size,
    position: 'absolute',
    left: size / 1.65,
    top: size / 3.2
  }

}));
